import { BaseModel } from '../base.model';
import { JsonProperty } from '../json-map.util';
import { ExerciseRecentPerformanceModel } from './exercise-recent-performance.model';

class RecentPerformanceModel extends BaseModel {
  totalCount: number = undefined;
  @JsonProperty({ clazz: ExerciseRecentPerformanceModel })
  exercisesPerformance: ExerciseRecentPerformanceModel[] = undefined;
}

export { RecentPerformanceModel };
